import _ from 'underscore';
import classNames from 'classnames';
import React, { useCallback, useRef, useMemo } from 'react';
// import { SearchBox } from '@bingads-webui-react/fabric-control';

import {
  // AssetTypeToggleButtonsFilter,
  ImportSourceFilter,
  AssetSourceFilter,
  ImageSizeFilter,
  // VideoDurationFilter,
  DateAddedFilter,
  SearchBoxFilter,
} from './components';
import {
  CSMLTimeFrame,
  FilterType,
  // getAssetTypeOptions,
  getImportSourceOptions,
  getAssetSourceOptions,
  getDateAddedChoiceOptions,
} from '../model';
import { civilDateRangeEqual, getDefaultDateRange } from '../utils';

// export const AssetTypeFilterComponent = React.memo(({
//   filter, focused, onValueChange, onDropdownDismiss, i18n,
// }) => {
//   const { value } = filter || {};
//   const { assetTypeFilter } = value || {};
//   const dropdownOptions = useMemo(() => getAssetTypeOptions(i18n), [i18n]);

//   const onChange = useCallback((newValue, newHumanizedVaue) => {
//     if (newValue !== assetTypeFilter) {
//       onValueChange(filter, { assetTypeFilter: newValue }, newHumanizedVaue);
//     }
//   }, [assetTypeFilter, filter, onValueChange]);

//   return (
//     <div className={classNames('dropdown-filter-container', 'asset-type-filter')}>
//       <AssetTypeToggleButtonsFilter
//         defaultAssetType={assetTypeFilter}
//         assetTypeFilterOptions={dropdownOptions}
//         dropdownWidth="auto"
//         onChange={onChange}
//         onDismiss={(newValue, newHumanizedValue) => onDropdownDismiss(filter, { assetTypeFilter: newValue }, newHumanizedValue)}
//         focused={focused}
//         i18n={i18n}
//       />
//     </div>
//   );
// });

export const ImportSourceFilterComponent = React.memo(({
  filter, i18n, onValueChange, onDropdownDismiss, defaultOpen,
}) => {
  const { value } = filter || {};
  const { importSource } = value || {};
  const dropdownOptions = useMemo(() => getImportSourceOptions(i18n), [i18n]);

  const onChange = useCallback((newValue, newHumanizedVaue) => {
    const option = _.find(dropdownOptions, { key: newValue }) || {};
    if (newValue !== importSource) {
      onValueChange(filter, { importSource: newValue }, option.text || newHumanizedVaue);
    }
  }, [dropdownOptions, filter, importSource, onValueChange]);

  const onDismiss = useCallback((newValue, newHumanizedValue) => {
    const option = _.find(dropdownOptions, { key: newValue }) || {};
    onDropdownDismiss(filter, { importSource: newValue }, option.text || newHumanizedValue);
  }, [dropdownOptions, filter, onDropdownDismiss]);

  return (
    <div className={classNames('dropdown-filter-container', 'ads-studio-import-source-filter')}>
      <ImportSourceFilter
        defaultOpen={defaultOpen}
        defaultImportSource={importSource}
        options={dropdownOptions}
        onChange={onChange}
        onDismiss={onDismiss}
        i18n={i18n}
      />
    </div>
  );
});

export const AssetSourceFilterComponent = React.memo(({
  filter, i18n, onValueChange, onDropdownDismiss, defaultOpen,
}) => {
  const { value } = filter || {};
  const { assetSources } = value || {};
  const assetSourceOptions = useMemo(() => getAssetSourceOptions(i18n), [i18n]);
  const onChange = useCallback((newAssetSources, newHumanizedVaue) => {
    if (!_.isEqual(assetSources, newAssetSources)) {
      onValueChange(filter, { assetSources: newAssetSources }, newHumanizedVaue);
    }
  }, [assetSources, filter, onValueChange]);

  const onDismiss = useCallback((newValue, newHumanizedValue) => {
    onDropdownDismiss(filter, { assetSources: newValue }, newHumanizedValue);
  }, [filter, onDropdownDismiss]);

  return (
    <div className={classNames('dropdown-filter-container', 'ads-studio-asset-source-filter')}>
      <AssetSourceFilter
        defaultOpen={defaultOpen}
        defaultSelectedAssetSources={assetSources || []}
        options={assetSourceOptions}
        onChange={onChange}
        onDismiss={onDismiss}
        i18n={i18n}
      />
    </div>
  );
});

export const ImageSizeFilterComponent = React.memo(({
  filter, i18n, onValueChange, onDropdownDismiss, defaultOpen,
}) => {
  const { value } = filter || {};
  const { minImageWidth, minImageHeight } = value || {};

  const onImageSizeChange = useCallback((newValue, newHumanizedVaue) => {
    const { newMinWidth, newMinHeight } = newValue || {};
    if (minImageWidth !== newMinWidth || minImageHeight !== newMinHeight) {
      onValueChange(filter, { minImageWidth: newMinWidth, minImageHeight: newMinHeight }, newHumanizedVaue);
    }
  }, [filter, minImageHeight, minImageWidth, onValueChange]);

  const onDismiss = useCallback((newValue, newHumanizedValue) => {
    const { newMinWidth, newMinHeight } = newValue || {};
    onDropdownDismiss(filter, { minImageWidth: newMinWidth, minImageHeight: newMinHeight }, newHumanizedValue);
  }, [filter, onDropdownDismiss]);

  return (
    <div className={classNames('dropdown-filter-container', 'ads-studio-image-size-filter')}>
      <ImageSizeFilter
        defaultOpen={defaultOpen}
        defaultMinWidth={minImageWidth}
        defaultMinHeight={minImageHeight}
        onChange={onImageSizeChange}
        onDismiss={onDismiss}
        i18n={i18n}
      />
    </div>
  );
});

// export const VideoDurationFilterComponent = React.memo(({
//   filter, focused, i18n, onValueChange, onDropdownDismiss,
// }) => {
//   const { value } = filter || {};
//   const { minVideoDuration, maxVideoDuration } = value || {};

//   const onChange = useCallback((newValue, newHumanizedVaue) => {
//     const { newMinDuration, newMaxDuration } = newValue || {};
//     if (minVideoDuration !== newMinDuration || maxVideoDuration !== newMaxDuration) {
//       onValueChange(filter, { minVideoDuration: newMinDuration, maxVideoDuration: newMaxDuration }, newHumanizedVaue);
//     }
//   }, [filter, maxVideoDuration, minVideoDuration, onValueChange]);

//   const onDismiss = useCallback((newValue, newHumanizedValue) => {
//     const { newMinDuration, newMaxDuration } = newValue || {};
//     onDropdownDismiss(filter, { minVideoDuration: newMinDuration, maxVideoDuration: newMaxDuration }, newHumanizedValue);
//   }, [filter, onDropdownDismiss]);

//   return (
//     <div className={classNames('dropdown-filter-container', 'video-duration-filter')}>
//       <VideoDurationFilter
//         defaultMinDuration={minVideoDuration}
//         defaultMaxDuration={maxVideoDuration}
//         dropdownWidth="auto"
//         onChange={onChange}
//         onDismiss={onDismiss}
//         focused={focused}
//         i18n={i18n}
//       />
//     </div>
//   );
// });

export const AL_DATE_ADDED_FILTER_DEFAULT_RANGE = getDefaultDateRange();
export const DateAddedFilterComponent = React.memo(({
  filter, i18n, onValueChange, onDropdownDismiss, ianaTimeZone, dateFormat, defaultOpen,
}) => {
  const { value } = filter || {};
  const { dateAddedFilter, dateAddedFilterCustomDateRange = AL_DATE_ADDED_FILTER_DEFAULT_RANGE } = value || {};
  const dateAddedChoiceOptions = useMemo(() => getDateAddedChoiceOptions(i18n, ianaTimeZone), [i18n, ianaTimeZone]);

  const onChange = useCallback((newValue, newHumanizedVaue) => {
    const { timeframe: tf, customDateRange: cdr } = newValue || {};
    if (tf !== dateAddedFilter || !civilDateRangeEqual(cdr, dateAddedFilterCustomDateRange)) {
      onValueChange(filter, { dateAddedFilter: tf, dateAddedFilterCustomDateRange: cdr }, newHumanizedVaue);
    }
  }, [dateAddedFilter, dateAddedFilterCustomDateRange, filter, onValueChange]);

  const onDismiss = useCallback((newValue, newHumanizedValue) => {
    const { timeframe: tf, customDateRange: cdr } = newValue || {};
    onDropdownDismiss(filter, { dateAddedFilter: tf, dateAddedFilterCustomDateRange: cdr }, newHumanizedValue);
  }, [filter, onDropdownDismiss]);

  return (
    <div className={classNames('dropdown-filter-container', 'ads-studio-date-added-filter')}>
      <DateAddedFilter
        defaultOpen={defaultOpen}
        defaultTimeFrame={dateAddedFilter || CSMLTimeFrame.Anytime}
        defaultCustomDateRange={dateAddedFilterCustomDateRange}
        options={dateAddedChoiceOptions}
        onChange={onChange}
        onDismiss={onDismiss}
        timeZone={ianaTimeZone}
        dateFormat={dateFormat}
        i18n={i18n}
      />
    </div>
  );
});

export const PerformanceSearchTextFilterComponent = React.memo(({ i18n, filter, onValueChange }) => {
  const { value, title } = filter || {};
  const { searchText } = value || {};

  const searchTextValueRef = useRef('');
  const onSearchTextChanging = useCallback((evt, newValue) => {
    searchTextValueRef.current = newValue || '';
  }, []);

  const onSearchTextChange = useCallback((newValue) => {
    if (newValue !== searchText) {
      onValueChange(filter, { searchText: newValue }, newValue);
    }
  }, [filter, onValueChange, searchText]);

  const onSearchTextBlur = useCallback(() => {
    onSearchTextChange(searchTextValueRef.current);
  }, [onSearchTextChange]);


  const onSearchTextClear = useCallback(() => {
    onSearchTextChange('');
  }, [onSearchTextChange]);

  return (
    <div className={classNames('asset-library-search')}>
      <SearchBoxFilter
        i18n={i18n}
        ariaLabel={i18n.getString(_TL_('toolbar area search'))}
        // logger={logger}
        onSearchTextChanging={onSearchTextChanging}
        onSearchTextChange={onSearchTextChange}
        onSearchTextBlur={onSearchTextBlur}
        onSearchTextClear={onSearchTextClear}
        defaultSearchText={searchText || ''}
        searchboxPlaceHolder={i18n.getString(title)}
      />
      {/* <SearchBox
        placeholder={i18n.getString(title)}
        showIcon
        defaultValue={searchText || ''}
        onSearch={onSearchTextChange}
        onClear={onSearchTextClear}
        onChange={onSearchTextChanging}
        onBlur={onSearchTextBlur}
      /> */}
    </div>
  );
});

export const getPerformanceFilterComponents = ({ isAdsStudioAIGCMVPEnabled }) => {
  const ComponentMap = {
    // [FilterType.AssetType]: AssetTypeFilterComponent,
    [FilterType.ImportSource]: !isAdsStudioAIGCMVPEnabled ? ImportSourceFilterComponent : undefined,
    [FilterType.AssetSource]: isAdsStudioAIGCMVPEnabled ? AssetSourceFilterComponent : undefined,
    [FilterType.ImageSize]: ImageSizeFilterComponent,
    // [FilterType.VideoDuration]: VideoDurationFilterComponent,
    [FilterType.DateAdded]: DateAddedFilterComponent,
    [FilterType.SearchText]: PerformanceSearchTextFilterComponent,
  };
  return ComponentMap;
};
